// Clinic app guards rows 4 and 5 (Frontend §5.3) as pure functions over `/v1/me`.
import { activeMemberships, type Me } from '@pa/staff'

/** Row 4, `/`: one active membership → that clinic; several → the picker. (Impersonation, task 13, comes first.) */
export function homeHref(me: Me): string {
  if (me.impersonation) return `/clinics/${me.impersonation.clinic.id}/appointments`
  const active = activeMemberships(me)
  if (active.length === 1 && active[0]) return `/clinics/${active[0].clinic.id}/appointments`
  return '/select-clinic'
}

/** Row 5, `/clinics/$clinicId/*`: the clinic must be an active membership (or the impersonated clinic). */
export function clinicFor(me: Me, clinicId: string) {
  if (me.impersonation?.clinic.id === clinicId) return me.impersonation.clinic
  return activeMemberships(me).find((m) => m.clinic.id === clinicId)?.clinic ?? null
}
